import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getMessage } from "../data/locales";
import {
  formatBillingPhoneInput,
  getBillingPhoneMaxLength,
  getBillingPhonePlaceholder,
} from "../utils/billingPhone";
import { validateSpanishBizumMobile } from "../utils/bizumPhone";
import "./BizumFlow.css";

const BIZUM_PHONE_COUNTRY = "ES";

const BizumFlow = ({ onStartPayment, loading, initialPhone, guardError }) => {
  const [phone, setPhone] = useState(() =>
    formatBillingPhoneInput(initialPhone || "", BIZUM_PHONE_COUNTRY),
  );
  const [phoneError, setPhoneError] = useState("");

  useEffect(() => {
    setPhone(formatBillingPhoneInput(initialPhone || "", BIZUM_PHONE_COUNTRY));
    setPhoneError("");
  }, [initialPhone]);

  const handlePhoneChange = (event) => {
    setPhone(formatBillingPhoneInput(event.target.value, BIZUM_PHONE_COUNTRY));
    if (phoneError) {
      setPhoneError("");
    }
  };

  const handlePay = () => {
    const validation = validateSpanishBizumMobile(phone);
    if (!validation.valid) {
      setPhoneError(getMessage(validation.errorKey));
      return;
    }
    setPhoneError("");
    onStartPayment(validation.normalized);
  };

  const displayError = phoneError || guardError || "";
  const phoneDescribedBy = displayError ? "bizum-phone-help bizum-phone-error" : "bizum-phone-help";

  return (
    <div className="bizum-flow fade-in">
      <p className="mb-3">{getMessage("checkout.bizumRedirectHelp")}</p>
      <div className="mb-3 text-start">
        <label htmlFor="bizum-phone" className="form-label">
          {getMessage("checkout.bizumPhoneLabel")}
        </label>
        <input
          type="tel"
          id="bizum-phone"
          name="bizumPhone"
          className={`form-control${displayError ? " is-invalid" : ""}`}
          value={phone}
          onChange={handlePhoneChange}
          placeholder={getBillingPhonePlaceholder(BIZUM_PHONE_COUNTRY)}
          maxLength={getBillingPhoneMaxLength(BIZUM_PHONE_COUNTRY)}
          inputMode="tel"
          autoComplete="tel"
          aria-invalid={Boolean(displayError)}
          aria-describedby={phoneDescribedBy}
          required
          disabled={loading}
        />
        <div id="bizum-phone-help" className="form-text">
          {getMessage("checkout.bizumPhoneHelp")}
        </div>
        {displayError ? (
          <div id="bizum-phone-error" className="invalid-feedback d-block" role="alert">
            {displayError}
          </div>
        ) : null}
      </div>
      <button
        type="button"
        aria-busy={loading}
        onClick={handlePay}
        disabled={loading}
        className="btn btn-primary w-100 py-2"
        style={{ backgroundColor: "#e6007e", borderColor: "#e6007e" }}
      >
        {loading ? getMessage("checkout.bizumPaying") : getMessage("checkout.bizumPay")}
      </button>
    </div>
  );
};

BizumFlow.propTypes = {
  onStartPayment: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  initialPhone: PropTypes.string,
  guardError: PropTypes.string,
};

BizumFlow.defaultProps = {
  loading: false,
  initialPhone: "",
  guardError: "",
};

export default BizumFlow;
